import { Component, Input, Output, EventEmitter } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-circle-icon-button',
  standalone: true,
  imports: [
    MatIconModule,
    MatMenuModule,
    MatTooltipModule
],
  templateUrl: './circle-icon-button.component.html',
  styleUrl: './circle-icon-button.component.scss'
})
export class CircleIconButtonComponent {
  @Input() icon: string = 'add';
  @Input() matMenuTriggerFor?: any;
  @Input() disabled: boolean = false;
  @Input() color: string = '#666';
  @Input() backgroundColor: string = '#f5f5f5';
  @Input() hoverBackgroundColor: string = '#e9ecef';
  @Input() title?: string;
  
  @Output() clicked = new EventEmitter<Event>();

  onClick(event: Event) {
    if (!this.disabled && !this.matMenuTriggerFor) {
      this.clicked.emit(event);
    }
  }
}